<template>
  <div class="table-datepicker-filter">
    <VDialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="date"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="slot-wrapper">
          <slot
            :placeholder="placeholder"
            :nonRangeDate="nonRangeDate"
            :startDate="startDate"
            :finalDate="finalDate"
            :rawStartDate="rawStartDate"

            :openModal="openModal"
          >
            <div class="input-group-sm">
              <button
                class="form-control date-picker-button"
                :class="{'is-placeholder': isPlaceholder}"
                :placeholder="placeholder"

                style="width: 100%"
                @click="openModal"
              >
                <slot name="heading"></slot>
                <span class="mt-0.5 mr-1">
                  <i class="v-icon notranslate mdi mdi-calendar-multiselect theme--light"></i>
                </span>
                <span v-if="isPlaceholder">
                  {{ placeholder }}
                </span>
                <span v-else-if="!range">
                  {{ nonRangeDate }}
                </span>
                <div v-else>
                  <div v-if="startDate">
                    {{ startDate }}
                  </div>
                  <div v-if="finalDate">
                    {{ finalDate }}
                  </div>
                </div>
              </button>
            </div>
          </slot>

          <span v-if="!isPlaceholder" class="close-icon" @click.stop.prevent="removeDate">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </span>
        </div>
      </template>

      <VDatePicker
        v-model="date"
        color="#1867c0"
        :range="range"

        scrollable
      >
      <VSpacer></VSpacer>
        <VBtn
          text
          color="#1867c0"
          @click="modal = false"
        >
          Cancel
        </VBtn>
        <VBtn
          text
          color="#1867c0"
          @click="saveDate"
        >
          OK
        </VBtn>
      </VDatePicker>
    </VDialog>
  </div>
</template>

<script>

// v-icon notranslate mdi mdi-chevron-left theme--light

import { VDatePicker, VDialog, VBtn, VSpacer } from "vuetify/lib"

import { format } from "date-fns"
import mom from "moment"

export default {
  components: {
    VDialog,
    VDatePicker,
    VBtn,
    VSpacer,
  },
  props: {
    updateModelOnConfirmation: Boolean,

    value: {
      default: "",
    },
    initial_date: {
      type: String,
      default: "",
    },
    final_date: {
      type: String,
      default: "",
    },
    range: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Selecteer een datum...",
    },
  },
  data() {
    return {
      date: this.range ? ([
        this.initial_date && mom(this.initial_date).format("YYYY-MM-DD"),
        this.final_date && mom(this.final_date).format("YYYY-MM-DD"),
      ]).filter(date => date) : this.value && mom(this.value).format("YYYY-MM-DD"),
      modal: false,
      opened: false,
    }
  },
  created() {
    if (this.value && this.value.includes("000Z")) {
      this.date = format(new Date(this.value), "yyyy-MM-dd")
    }
  },
  methods: {
    saveDate() {
      this.$refs.dialog.save(this.date)
      this.updateModelOnConfirmation && this.$nextTick(() => this.updateModel())
    },
    openModal() {
      this.modal = true
    },
    checkClickPath(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (node === this.$el) {
          found = true
          break
        }
      }

      if (!found) this.opened = false
    },
    formatStringDate(date) {
      try {
        return date && format(new Date(date + " 00:00"), "dd-MM-yyyy")
      } catch (err) {
        return date
      }
    },
    removeDate() {
      if (this.range) {
        this.$emit("update:initial_date", null)
        this.$emit("update:final_date", null)
      } else {
        this.$emit("input", null)
      }
    },
    updateModel() {
      const val = this.date

      // console.log("date", val)
      if (this.range) {
        let initial = val[0]
        let last = val[1]

        if(mom(new Date(last)).isBefore(mom(new Date(initial)))) {
          let temp = last
          last = initial
          initial = temp
        }

        this.$emit("update:initial_date", initial)
        this.$emit("update:final_date", last)
      } else {
        this.$emit("input", val)
      }

      this.opened = false
    },
  },
  computed: {
    nonRangeDate() {
      return this.formatStringDate(this.date)
    },
    rawStartDate() {
      const date = this.date
      return this.formatStringDate(date && (typeof date === "object" ? date[0] : date))
    },
    startDate() {
      const date = this.rawStartDate
      return date && `From: ${date}`
    },
    finalDate() {
      const date = this.formatStringDate(this.date && this.date[1])
      return date && `To: ${date}`
    },
    datePickerValue() {
      return this.range ? ([this.initial_date, this.final_date]).filter(date => date) : this.value
    },
    isPlaceholder() {
      return this.range ? !this.date.length : !this.date
    },
  },
  watch: {
    date() {
      !this.updateModelOnConfirmation && this.updateModel()
    },
    datePickerValue(val) {
      this.date = val
    },
    opened(val) {
      if (val) {
        window.addEventListener("click", this.checkClickPath)
      } else {
        window.removeEventListener("click", this.checkClickPath)
      }
    },
  },
}

</script>

<style>

.table-datepicker-filter td,
.table-datepicker-filter th,
.table-datepicker-filter tr {
  border: none !important;
  padding: 8px;
}

.v-dialog__container {
  display: block !important;
}

.v-dialog__content--active {
  background-color: rgba(0,0,0, .2);
  pointer-events: all;
}

</style>

<style scoped>


.form-group {
  margin-bottom: 0px !important;
}

.slot-wrapper {
  position: relative;
}

.form-control {
  display: flex;
  height: auto !important;
  position: relative;
  text-align: left !important;
  border-radius: 1px;
  padding-top: 8px !important;
  padding-bottom: 7px !important;
  padding-right: 40px !important;
}

.close-icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 28px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition-duration: .2s;
}

.close-icon:hover svg {
  color: #EF4444;
}

.is-placeholder, .is-placeholder i {
  color: #ddd;
}

.v-icon {
  font-size: 1em;
}
</style>

